import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">探索不同维度的白洁故事与情感话题</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}